import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

import { PasswordInput } from "@/components/PasswordInput";

const pinp = "h-12 rounded-md px-3 text-lg font-normal";
const inp = `w-full mt-1.5 ${pinp}`;
const btn = "w-full bg-[#DC2626] hover:bg-[#B91C1C] disabled:opacity-60 text-white font-display font-bold text-lg py-3.5 rounded-full transition-colors";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [step, setStep] = useState(token ? "new" : "email");
  const [f, setF] = useState({ email: "", code: "", password: "", password2: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const ask = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email: f.email }); setStep("code"); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const reset = async (e) => {
    e.preventDefault();
    if (f.password !== f.password2) return toast.error("Las dos contraseñas no coinciden");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", token ? { token, password: f.password } : { email: f.email, code: f.code, password: f.password });
      toast.success("Contraseña cambiada. Ya puedes entrar con la nueva.");
      nav("/login");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const pw = (<>
    <label className="block text-base font-bold">Nueva contraseña<PasswordInput required minLength={6} autoComplete="new-password" value={f.password} onChange={set("password")} className={pinp} testId="reset-password" /></label>
    <label className="block text-base font-bold">Repite la contraseña<PasswordInput required minLength={6} autoComplete="new-password" value={f.password2} onChange={set("password2")} className={pinp} testId="reset-password2" /></label>
  </>);
  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="reset-page">
      <KeyRound size={36} className="text-[#DC2626]" />
      <h1 className="font-display font-black text-4xl text-[#0B1D3A] mt-3">Recuperar contraseña</h1>
      {step === "email" && (
        <form onSubmit={ask} className="space-y-4 mt-6">
          <p className="text-slate-600">Escribe el email de tu cuenta. Te enviaremos un enlace y un código de 6 cifras, válidos durante 1 hora.</p>
          <label className="block text-base font-bold">Email<input autoComplete="email" type="email" required value={f.email} onChange={set("email")} className={inp} data-testid="reset-email" /></label>
          <button disabled={busy} className={btn} data-testid="reset-send">{busy ? "Enviando…" : "Enviar"}</button>
        </form>
      )}
      {step === "code" && (
        <form onSubmit={reset} className="space-y-4 mt-6">
          <p className="text-slate-600 bg-[#EFF6FF] rounded p-3 text-sm" data-testid="reset-sent">Si <b>{f.email}</b> tiene cuenta, te hemos enviado un email. Pulsa el enlace o escribe aquí el código. Revisa también la carpeta de spam.</p>
          <label className="block text-sm font-bold">Código de 6 cifras<input inputMode="numeric" required pattern="\d{6}" maxLength={6} value={f.code} onChange={set("code")} className={`${inp} tracking-[0.5em] text-lg font-bold`} data-testid="reset-code" /></label>
          {pw}
          <button disabled={busy} className={btn} data-testid="reset-submit">{busy ? "Un momento…" : "Cambiar contraseña"}</button>
          <button type="button" onClick={() => setStep("email")} className="text-sm font-bold text-[#2563EB]" data-testid="reset-resend">No me ha llegado: enviar de nuevo</button>
        </form>
      )}
      {step === "new" && (
        <form onSubmit={reset} className="space-y-4 mt-6">
          <p className="text-slate-600">Elige tu nueva contraseña (mínimo 6 caracteres).</p>
          {pw}
          <button disabled={busy} className={btn} data-testid="reset-submit">{busy ? "Un momento…" : "Cambiar contraseña"}</button>
        </form>
      )}
      <Link to="/login" className="block mt-8 text-sm font-bold text-[#2563EB]" data-testid="reset-back">← Volver a entrar</Link>
    </div>
  );
}
